// assets/nd-quote-factor-alert.js
// Show a nice center popup after loading a quote back into the cart

(function () {
  if (window.__ND_FACTOR_ALERT__) return;
  window.__ND_FACTOR_ALERT__ = true;

  var path = (window.location.pathname || '').toLowerCase();
  if (path.indexOf('/cart') === -1) return; // Run on cart page only

  function showFactorModal() {
    // Save current body overflow to restore later
    var prevOverflow = document.body.style.overflow || '';

    // Overlay
    var overlay = document.createElement('div');
    overlay.id = 'nd-factor-modal-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.zIndex = '9999';
    overlay.style.background = 'rgba(0,0,0,0.35)';
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.padding = '16px';
    overlay.style.boxSizing = 'border-box';

    // Dialog
    var dialog = document.createElement('div');
    dialog.style.maxWidth = '440px';
    dialog.style.width = '100%';
    dialog.style.background = '#ffffff';
    dialog.style.borderRadius = '14px';
    dialog.style.boxShadow = '0 18px 40px rgba(15,23,42,0.35)';
    dialog.style.padding = '20px 22px 18px';
    dialog.style.boxSizing = 'border-box';
    dialog.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
    dialog.style.color = '#111827';
    dialog.style.position = 'relative';

    // Small label
    var label = document.createElement('div');
    label.textContent = 'QUICK REMINDER';
    label.style.fontSize = '11px';
    label.style.letterSpacing = '0.08em';
    label.style.textTransform = 'uppercase';
    label.style.fontWeight = '600';
    label.style.color = '#6B7280';
    label.style.marginBottom = '6px';
    dialog.appendChild(label);

    // Title
    var title = document.createElement('div');
    title.textContent = 'Info Double-Check';
    title.style.fontSize = '18px';
    title.style.fontWeight = '600';
    title.style.marginBottom = '6px';
    dialog.appendChild(title);

    // Body text
    var body = document.createElement('div');
    body.style.fontSize = '14px';
    body.style.lineHeight = '1.6';
    body.style.color = '#374151';
    body.style.marginBottom = '14px';
    body.innerHTML =
      '<strong>Please double-check discount factor and Reference # before saving or submitting your quote.</strong><br>'
    dialog.appendChild(body);

    // Button row
    var btnRow = document.createElement('div');
    btnRow.style.display = 'flex';
    btnRow.style.justifyContent = 'flex-end';
    btnRow.style.gap = '8px';
    btnRow.style.marginTop = '4px';

    // Secondary button (optional: "Close")
    var btnSecondary = document.createElement('button');
    btnSecondary.type = 'button';
    btnSecondary.textContent = 'Close';
    btnSecondary.style.padding = '7px 14px';
    btnSecondary.style.fontSize = '13px';
    btnSecondary.style.borderRadius = '9999px';
    btnSecondary.style.border = '1px solid #D1D5DB';
    btnSecondary.style.background = '#FFFFFF';
    btnSecondary.style.color = '#374151';
    btnSecondary.style.cursor = 'pointer';

    // Primary button
    var btnPrimary = document.createElement('button');
    btnPrimary.type = 'button';
    btnPrimary.textContent = 'Got it';
    btnPrimary.style.padding = '7px 16px';
    btnPrimary.style.fontSize = '13px';
    btnPrimary.style.borderRadius = '9999px';
    btnPrimary.style.border = 'none';
    btnPrimary.style.background = '#111827';
    btnPrimary.style.color = '#FFFFFF';
    btnPrimary.style.cursor = 'pointer';
    btnPrimary.style.fontWeight = '500';

    btnRow.appendChild(btnSecondary);
    btnRow.appendChild(btnPrimary);
    dialog.appendChild(btnRow);

    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    // Prevent background scroll
    document.body.style.overflow = 'hidden';

    function closeModal() {
      document.body.style.overflow = prevOverflow;
      if (overlay && overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    }

    // Close by buttons
    btnPrimary.addEventListener('click', closeModal);
    btnSecondary.addEventListener('click', closeModal);

    // Close by clicking outside dialog
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        closeModal();
      }
    });

    // Simple keyboard support (Esc)
    document.addEventListener('keydown', function escListener(e) {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', escListener);
      }
    });

    // Focus primary button
    setTimeout(function () {
      btnPrimary.focus();
    }, 50);
  }

  try {
    var flag = sessionStorage.getItem('ND_NEUMA_QUOTE_LOADED');
    if (flag === '1') {
      sessionStorage.removeItem('ND_NEUMA_QUOTE_LOADED');
      // Slight delay to let the cart page finish rendering
      setTimeout(showFactorModal, 400);
    }
  } catch (e) {
    console.warn('[ND Factor Alert] sessionStorage not available', e);
  }
})();
